import React from 'react';
// Images
import SmallMainImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-with-slave-and-flogger.webp';
// Constants
import { CompanyName } from '../../utils/Constants';

function AboutInfoContainer() {
  return (
    <section className='grid w-full'>
      <div className='grid md:grid-cols-reg text-center'>
        {/* Image Section */}
        <section className='grid items-center'>
          <section>
            <img
              src={SmallMainImage}
              alt={`${CompanyName}`}
              className='mx-auto h-full object-cover lg:max-w-[25vw]'
            />
          </section>
        </section>

        {/* About Content */}
        <section className='grid w-full bg-colour4 full_shadow_black_invert'>
          <article className='grid gap-y-8 px-6 sm:px-8 md:px-12 lg:max-w-[80%] lg:mx-auto my-auto py-4 lg:py-8 lg:text-xl text-left text-colour1 dark:text-colour1'>
            <div>
              <h3 className='font-argesta text-xl lg:text-3xl tracking-widest'>
                "About Queen Diva..."
              </h3>
            </div>

            <div className='text-base lg:text-lg font-argesta grid h-fit gap-y-4'>
              <p>
                “Training slaves and submissives is My passion… watching slaves
                suffer is My ultimate pleasure.”
              </p>
              <p>
                Anal Play, Pegging, Strap On, Figging, tease and desperation are
                just a few of My favourite’s. It is a place where you willing to
                do anything for gratification, and at that moment, My power over
                you is absolute.
              </p>
              <p>
                I especially enjoy novices, and the opportunity of taking one’s
                virginity. If you require some encouragement, I have a whole
                array of different implements from beginner to very advanced.
              </p>
              <p>
                If you feel inspired to bestow a gift, gifts are by no means
                obligatory however, for a certain breed of gentleman, the
                selfless act of giving, perfectly sets the tone for your
                submission. Enquire for some My favourites.
              </p>
            </div>
          </article>
        </section>
      </div>
    </section>
  );
}

export default AboutInfoContainer;
